import { render, staticRenderFns } from "./PwaStyleSettings.vue?vue&type=template&id=79407b1e&scoped=true&"
import script from "./PwaStyleSettings.vue?vue&type=script&lang=js&"
export * from "./PwaStyleSettings.vue?vue&type=script&lang=js&"
import style0 from "./PwaStyleSettings.vue?vue&type=style&index=0&id=79407b1e&scoped=true&lang=css&"
import style1 from "./PwaStyleSettings.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79407b1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VRow,VSwitch,VTooltip})
